import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=1fa4e570&scoped=true&"
import script from "./companies.vue?vue&type=script&lang=js&"
export * from "./companies.vue?vue&type=script&lang=js&"
import style1 from "./companies.vue?vue&type=style&index=1&id=1fa4e570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4e570",
  null
  
)

export default component.exports